import { render } from "./About.component.vue?vue&type=template&id=7c4c4b0e"
import script from "./About.component.vue?vue&type=script&lang=js"
export * from "./About.component.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__